import React from 'react';
import iconoDisclaimer from '../../assets/icono-disclaimer.png';
import styles from './spei-warnings.module.css';

export const SpeiWarnings = () => (
  <div className={styles.warnings}>
    <div className={styles.nameNotice}>
      EL NOMBRE DEL TITULAR DE LA CUENTA BANCARIA DEBE DE SER EL MISMO QUE EL NOMBRE EN TU CUENTA DE
      PICKWIN. SI NO ES ASÍ, TU DEPOSITO NO SERÁ PROCESADO.
    </div>

    <div className={styles.rememberCard}>
      <div className={styles.rememberHeader}>
        <img src={iconoDisclaimer} alt="" className={styles.rememberIcon} />
        <div className={styles.rememberTitle}>¡RECUERDA!</div>
      </div>
      <p className={styles.rememberText}>
        Las transferencias bancarias tardan entre 30 minutos a 1 hora en verse reflejadas en tu
        saldo.
      </p>
      <div className={styles.rememberDivider} />
      <p className={styles.rememberFooter}>
        ¡RECUERDA! EN LOS CASOS QUE APLIQUEN, LA CUENTA QUE USES PARA DEPOSITAR, SERÁ LA CUENTA QUE
        DEBERÁS USAR PARA SOLICITAR UN RETIRO DE TUS FONDOS.
      </p>
    </div>
  </div>
);
